import { render, staticRenderFns } from "./VehicleSettingsContent.vue?vue&type=template&id=3445b88e&scoped=true"
import script from "./VehicleSettingsContent.vue?vue&type=script&lang=ts"
export * from "./VehicleSettingsContent.vue?vue&type=script&lang=ts"
import style0 from "./VehicleSettingsContent.vue?vue&type=style&index=0&id=3445b88e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3445b88e",
  null
  
)

export default component.exports